/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scl_Withdrawal_Status_ClosedInputs */

const vi_scl_withdrawal_status_closed = /** @type {(inputs: Scl_Withdrawal_Status_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã đóng`)
};

/**

* @param {Scl_Withdrawal_Status_ClosedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const scl_withdrawal_status_closed = /** @type {((inputs?: Scl_Withdrawal_Status_ClosedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scl_Withdrawal_Status_ClosedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_scl_withdrawal_status_closed(inputs)
});